import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import some from 'lodash/some';
import get from 'lodash/get';
import AsyncSelect from 'react-select/async';
import MAX_GROUP_TO_ADD from '@integrations/pint-appstore-commons/src/enums/GROUPS.json';
import { searchGroups } from '../../common/appStatusActionCreators';

let debounce;
const unsupportedSearchPhrases = ['.', '..'];

const loadOptions = (props) => (inputValue, callback) => {
    if (!inputValue || unsupportedSearchPhrases.find((unsupportedPhrase) => unsupportedPhrase === inputValue)) {
        return callback(null);
    }
    if (debounce) {
        clearTimeout(debounce);
    }
    debounce = setTimeout(
        () =>
            props
                .dispatchSearchGroups(inputValue)
                .then((response) => {
                    const options = response.value.groups
                        .filter((gr) => !some(props.selectedGroups, ['id', gr.id]))
                        .map((gr) => ({
                            value: { ...gr, inputKey: inputValue },
                            label: gr.name,
                        }));

                    callback(options);
                })
                .catch(() => callback(null)),
        1000
    );
};

function areEqual(prevProps, nextProps) {
    if (prevProps.className === nextProps.className && prevProps.selectedGroups === nextProps.selectedGroups) {
        return true;
    }

    return false;
}

const GroupsChooserSearch = React.memo(
    ({ dispatchSearchGroups, className, selectedGroupCallback, cache, selectedGroups }) => {
        const [value, setValue] = useState(null);

        return (
            <AsyncSelect
                isDisabled={selectedGroups && selectedGroups.length >= MAX_GROUP_TO_ADD.MAX_GROUP_TO_ADD}
                className={className}
                name="group-search-box"
                onChange={handleChange}
                value={value}
                cache={cache}
                loadOptions={loadOptions({ dispatchSearchGroups, selectedGroups })}
                clearable={false}
                placeholder={
                    <span>
                        <i className="fa fa-search" /> Search for groups to add...
                    </span>
                }
                noResultsText="No groups available"
                openOnClick={false}
                arrowRenderer={null}
                valueRenderer={(value) => (value ? getOptionRow(value.name) : null)}
                optionRenderer={(option) => getOptionRow(option.label)}
                styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
                menuPosition="fixed"
                menuPortalTarget={document.body}
            />
        );

        function handleChange(selectedOption) {
            Object.keys(cache).forEach((member) => {
                Object.keys(cache[member]).forEach((memberI) => {
                    if (get(cache, `[${member}][${memberI}].value.id`) === selectedOption.value.id) {
                        delete cache[member][memberI];
                    }
                });
            });

            selectedGroupCallback(selectedOption.value);
            setValue(null);
            document.activeElement.blur();
        }

        function getOptionRow(optionName) {
            return <span className={`${className}__option`}>{optionName}</span>;
        }
    },
    areEqual
);

GroupsChooserSearch.propTypes = {
    className: PropTypes.string.isRequired,
    selectedGroups: PropTypes.array.isRequired,
    cache: PropTypes.object.isRequired,
    selectedGroupCallback: PropTypes.func.isRequired,
    dispatchSearchGroups: PropTypes.func.isRequired,
};
GroupsChooserSearch.displayName = 'GroupsChooserSearch';

const mapDispatchToProps = {
    dispatchSearchGroups: searchGroups,
};

export default connect((state) => state.appStatusForm, mapDispatchToProps)(GroupsChooserSearch);
